// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".timer{background-color:#f36c21;border-radius:50px;padding:4px 10px;font-size:16px;font-weight:bold}.timer i{font-size:18px !important;position:relative !important;top:-2px}.line-height .v-text-field__slot label{line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
